// extracted by mini-css-extract-plugin
export default {"root":"_2ZXRacL-MhmgfEAlfAu5g3","table":"_1wNywhMdzMnIeNvQRsOVaO","searchBtn":"_3kDoB_fQPVfIo36Lo-CX7N"};